import {Container} from '@/components/ui/container/Container'
import styled, {css} from 'styled-components'

export const StyledRouterErrorBoundaryContainer = styled(Container)(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: ${spacing * 6}px;
        justify-content: center;
    `
)

export const StyledErrorBoundaryHeading = styled.h2(
    ({theme: {typography, palette}}) => css`
        ${typography.displayMd};
        font-weight: 700;
        color: ${palette.neutral[950]};
    `
)

export const StyledErrorBoundaryMessage = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textXl};
        color: ${palette.neutral[700]};
    `
)
